import React from "react";
import {
  Box,
  Container,
  Paper,
  Link,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  Typography,
  Stack
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import moment from "moment";
import { config } from "../core/service/config.service";

const PHD_2A = "2a";
const PHD_2AB = "2ab";
const PHD_2C = "2c";

const PhD2A = (detail) => {
  const {
    current_total_credits,
    current_total_thesis_credits,
    gpa,
    gpax,
    main_research_area,
    previous_semester,
    received_grade_report_gpa,
    receiving_scholarship,
    remaining_credits_program,
    report_no,
    research_title,
    research_title_select,
    thesis_credits_program
  } = detail.data;

  const { grade_report } = detail;

  return (
    <Container>
      <Box>
        <Typography variant="h5" sx={{ paddingTop: 4 }}>
          2A: Grade Report for Previous Semester
        </Typography>

        <Stack
          sx={{ paddingTop: 2 }}
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={12}
        >
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Year of receiving scholarship:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {receiving_scholarship}
          </Typography>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Report No.
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>{report_no}</Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            For previous semester:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>{previous_semester}</Typography>
        </Stack>

        <Typography variant="h6" sx={{ paddingTop: 4 }}>
          Grade Report
        </Typography>

        <TableContainer component={Paper}>
          <Table fullWidth>
            <TableHead>
              <TableRow>
                <TableCell>Subject/Course No.</TableCell>
                <TableCell>Course Title</TableCell>
                <TableCell>Credit</TableCell>
                <TableCell>Grade</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {grade_report.map((row, i) => (
                <TableRow
                  key={i}
                  sx={{
                    "&:last-child td, &:last-child th": {
                      border: 0
                    }
                  }}
                >
                  <TableCell>{row.subject_course_no}</TableCell>
                  <TableCell>{row.course_title}</TableCell>
                  <TableCell>{row.credit}</TableCell>
                  <TableCell>{row.grade}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Reasons and Problem:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {received_grade_report_gpa}
          </Typography>
        </Stack>

        <Typography variant="h6" sx={{ paddingTop: 3 }}>
          Thesis Report
        </Typography>

        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={12}
        >
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Credit required:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {thesis_credits_program}
          </Typography>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Current thesis credits earned:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {current_total_thesis_credits}
          </Typography>
        </Stack>

        <Typography variant="h6" sx={{ paddingTop: 3 }}>
          Study Summary
        </Typography>

        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={12}
        >
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            GPA:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>{gpa}</Typography>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            GPAX:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>{gpax}</Typography>
        </Stack>

        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={12}
        >
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Credits required:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {remaining_credits_program}
          </Typography>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Current credits earned:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {current_total_credits}
          </Typography>
        </Stack>

        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={12}
        >
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Research Field:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {research_title_select}
          </Typography>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Main Research Area:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>{main_research_area}</Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Title:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>{research_title}</Typography>
        </Stack>
      </Box>
    </Container>
  );
};

const PhD2B = (detail) => {
  const {
    answer_country_plan,
    conducting_research_abroad6_months,
    high_performance_professor,
    institute_professor_collaborator,
    journal_ranking,
    manuscript_id,
    present_progress_research_project,
    professor_collaborator_name,
    proposal_examination_result,
    qualifying_exam_result,
    start_writing_research_proposal,
    subject_area_published,
    when_proposal_examination,
    when_qualifying_examination,
    upload_current_research_proposal,
    manuscript_publication
  } = detail.data;

  return (
    <Container>
      <Box>
        <Typography variant="h5" sx={{ paddingTop: 3 }}>
          2B: Progress Report
        </Typography>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Starting writing research proposal:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {start_writing_research_proposal}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={12} sx={{ paddingTop: 1 }}>
          <Typography variant="subtitle1">Research file:</Typography>
          <Link
            href={
              upload_current_research_proposal
                ? `${config.host_api}download/${upload_current_research_proposal}`
                : null
            }
          >
            {upload_current_research_proposal?.split("-").pop() || " "}
          </Link>
          <DownloadIcon />
        </Stack>

        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={12}
          variant="subtitle2"
          sx={{ paddingTop: 1 }}
        >
          <Typography variant="subtitle1">Qualifying Exam Result:</Typography>
          <Typography>{qualifying_exam_result}</Typography>
          <Typography variant="subtitle1">Date:</Typography>
          <Typography>
            {moment(when_qualifying_examination).format("DD/MM/YY")}
          </Typography>
        </Stack>

        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={12}
          variant="subtitle2"
          sx={{ paddingTop: 1 }}
        >
          <Typography variant="subtitle1">
            Proposal Examination Result:
          </Typography>
          <Typography>{proposal_examination_result}</Typography>
          <Typography variant="subtitle1">Date:</Typography>
          <Typography>
            {moment(when_proposal_examination).format("DD/MM/YY")}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Present progress:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {present_progress_research_project}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            List of Journal and Subject:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {subject_area_published}
          </Typography>
        </Stack>

        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={12}
          variant="subtitle2"
          sx={{ paddingTop: 1 }}
        >
          <Typography variant="subtitle1">File manuscript:</Typography>
          <Link
            href={
              manuscript_publication
                ? `${config.host_api}download/${manuscript_publication}`
                : null
            }
          >
            {manuscript_publication?.split("-").pop() || " "}
          </Link>
          <DownloadIcon />
          <Typography variant="subtitle1">Manuscript ID:</Typography>
          <Typography>{manuscript_id}</Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Journal ranking:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>{journal_ranking}</Typography>
        </Stack>

        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={12}
          variant="subtitle2"
          sx={{ paddingTop: 1 }}
        >
          <Typography variant="subtitle1">Future plan:</Typography>
          <Typography>{conducting_research_abroad6_months}</Typography>
          <Typography variant="subtitle1">Country:</Typography>
          <Typography>{answer_country_plan}</Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            International collaborator:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {high_performance_professor}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Name:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {professor_collaborator_name}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            University:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {institute_professor_collaborator}
          </Typography>
        </Stack>
      </Box>
    </Container>
  );
};

const PhD2C = (detail) => {
  const {
    accepted_date,
    article_title,
    authors,
    journal,
    journal_ranking2c,
    manuscript_id2c,
    present_progress_research_project2c,
    published_date,
    received_date,
    revised_date,
    subject_area_category,
    type_manuscript,
    your_research_field,
    upload_research_publication
  } = detail;

  return (
    <Container>
      <Box>
        <Typography variant="h6" sx={{ paddingTop: 3 }}>
          2C: Final Report
        </Typography>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Research Field:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>{your_research_field}</Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Present progress of the research project:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {present_progress_research_project2c}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Title:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>{article_title}</Typography>
        </Stack>

        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={12}
          variant="subtitle2"
          sx={{ paddingTop: 1 }}
        >
          <Typography variant="subtitle1">Manuscript ID:</Typography>
          <Typography>{manuscript_id2c}</Typography>
          <Typography variant="subtitle1">Type of Manuscript:</Typography>
          <Typography>{type_manuscript}</Typography>
        </Stack>

        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={12}
          variant="subtitle2"
          sx={{ paddingTop: 1 }}
        >
          <Typography variant="subtitle1">Journal:</Typography>
          <Typography>{journal}</Typography>
          <Typography variant="subtitle1">Journal ranking:</Typography>
          <Typography>{journal_ranking2c}</Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Subject area and category:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {subject_area_category}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Authors:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>{authors}</Typography>
        </Stack>

        <Stack direction="row" spacing={1} sx={{ paddingTop: 1 }}>
          <Typography variant="subtitle1">
            File research publication:
          </Typography>
          <Link
            href={
              upload_research_publication
                ? `${config.host_api}download/${upload_research_publication}`
                : null
            }
          >
            {upload_research_publication?.split("-").pop() || " "}
          </Link>
          <DownloadIcon />
        </Stack>

        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={12}
          variant="subtitle2"
          sx={{ paddingTop: 1 }}
        >
          <Typography variant="subtitle1">Received Date:</Typography>
          <Typography>{moment(received_date).format("DD/MM/YY")}</Typography>
          <Typography variant="subtitle1">Revised Date:</Typography>
          <Typography>{moment(revised_date).format("DD/MM/YY")}</Typography>
        </Stack>

        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={12}
          variant="subtitle2"
          sx={{ paddingTop: 1 }}
        >
          <Typography variant="subtitle1">Accepted date:</Typography>
          <Typography>{moment(accepted_date).format("DD/MM/YY")}</Typography>
          <Typography variant="subtitle1">Published date:</Typography>
          <Typography>{moment(published_date).format("DD/MM/YY")}</Typography>
        </Stack>
      </Box>
    </Container>
  );
};

export default function ApprovePhDModal2s({ detail }) {
  return (
    <>
      {detail?.data?.sending_scholarship_report === PHD_2A && PhD2A(detail)}

      {detail?.data?.sending_scholarship_report === PHD_2AB && PhD2A(detail)}

      {detail?.data?.sending_scholarship_report === PHD_2AB && PhD2B(detail)}

      {detail?.sending_scholarship_report === PHD_2C && PhD2C(detail)}
    </>
  );
}
